/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import PostOPInstruction from './post-op-instruction';
import PostOPInstructionDetail from './post-op-instruction-detail';
import PostOPInstructionUpdate from './post-op-instruction-update';
import PostOPInstructionDeleteDialog from './post-op-instruction-delete-dialog';

const PostOPInstructionRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<PostOPInstruction />} />
    <Route path="new" element={<PostOPInstructionUpdate />} />
    <Route path=":id">
      <Route index element={<PostOPInstructionDetail />} />
      <Route path="edit" element={<PostOPInstructionUpdate />} />
      <Route path="delete" element={<PostOPInstructionDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default PostOPInstructionRoutes;
